import { Helmet } from "react-helmet-async"
import { WhatsAppMessagesList } from "../../../../../../Integrations"
import { useOutletContext } from "react-router"

export default function WhatsAppIntegrationMessagesPage() {
	const context = useOutletContext<{
		integrationId: number
		appId: number
	}>()

	return (
		<>
			<Helmet>
				<title>Messages | WA</title>
			</Helmet>
			<WhatsAppMessagesList
				integratedAppId={context.appId}
				integrationId={context.integrationId}
			/>
		</>
	)
}
